import { OverlayTrigger, Tooltip } from "react-bootstrap";

const SATooltip = (props) => {

    
    if (!props?.title) {
        return props.children;
    }

    return (
        <OverlayTrigger
            placement={props?.placement || "top"}
            overlay={
                <Tooltip
                    className="custom-tooltip"
                    id="tooltip"
                    style={{
                        backgroundColor: (props?.bg || "#000") + " !important",
                        color: (props?.color || "#fff") + " !important",
                        zIndex: 100001
                    }}
                >
                    <span>{props?.title}</span>
                </Tooltip>
            }
        >
            {props.children}
        </OverlayTrigger>

    );
};

export default SATooltip;

